import { Box, Switch } from "@mui/material";
import {
  BORDER,
  BORDER_PURPLE,
  BG_PURPLE_TINT,
  RADIUS_INPUT,
  PURPLE_DARK,
  TEXT_BODY,
  TEXT_SUBTLE,
  TEXT_SECONDARY,
  cardLabelSx,
} from "./bentoTokens";

// Shared building blocks for Bento-redesigned data-entry forms (New Package, Package Edit, ...).
// Centralizes the floating-label field borders, focus colors, and pill switches so every
// later redesigned form references one source instead of re-hand-rolling the same sx.

export const sectionLabelSx = {
  ...cardLabelSx,
  fontSize: "11.5px",
  letterSpacing: ".1em",
  color: TEXT_SECONDARY,
  marginBottom: "16px",
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: RADIUS_INPUT,
    background: "#fff",
    "& .MuiOutlinedInput-notchedOutline": { borderColor: BORDER },
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: BORDER_PURPLE },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#a78bfa", borderWidth: "1.5px" },
  },
};

export const accentFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: RADIUS_INPUT,
    background: BG_PURPLE_TINT,
    "& .MuiOutlinedInput-notchedOutline": { borderColor: BORDER_PURPLE },
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#a78bfa" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#a78bfa", borderWidth: "1.5px" },
  },
  "& .MuiInputLabel-root": { color: PURPLE_DARK },
};

export const switchSx = {
  width: 44,
  height: 24,
  p: 0,
  flex: "none",
  "& .MuiSwitch-switchBase": {
    p: "3px",
    "&.Mui-checked": {
      transform: "translateX(20px)",
      "& + .MuiSwitch-track": { background: `linear-gradient(135deg,#7c3aed,${PURPLE_DARK})`, opacity: 1 },
    },
  },
  "& .MuiSwitch-thumb": { width: 18, height: 18, boxShadow: "0 1px 3px rgba(0,0,0,.18)" },
  "& .MuiSwitch-track": { borderRadius: 999, background: "#e5e7eb", opacity: 1 },
};

// Floating pill label for hand-rolled fields (e.g. a stepper) that aren't a MUI TextField,
// so they don't get the native notched-outline label for free.
export const FieldLabel = ({ children, htmlFor }) => (
  <Box
    component={htmlFor ? "label" : "div"}
    htmlFor={htmlFor}
    sx={{
      position: "absolute",
      top: "-9px",
      left: "12px",
      fontSize: "10.5px",
      fontWeight: 700,
      color: TEXT_SUBTLE,
      background: "#fff",
      padding: "0 4px",
      letterSpacing: ".06em",
      zIndex: 1,
    }}
  >
    {children}
  </Box>
);

export const ToggleCard = ({ label, sub, checked, onChange, disabled, children }) => (
  <Box
    sx={{
      border: `1.5px solid ${checked ? BORDER_PURPLE : BORDER}`,
      borderRadius: "14px",
      background: checked ? BG_PURPLE_TINT : "#fafafa",
      overflow: "hidden",
      transition: "border-color .15s, background .15s",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: "14px 16px" }}>
      <Box>
        <Box sx={{ fontSize: "13.5px", fontWeight: 700, color: TEXT_BODY }}>{label}</Box>
        {sub && <Box sx={{ fontSize: "11.5px", color: TEXT_SUBTLE, mt: "2px" }}>{sub}</Box>}
      </Box>
      <Switch checked={checked} onChange={onChange} disabled={disabled} sx={switchSx} />
    </Box>
    {children && <Box sx={{ p: "0 16px 14px" }}>{children}</Box>}
  </Box>
);
